export default "__VITE_PUBLIC_ASSET__0caacaf7__"